'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _placeholder = require('./components/placeholder');

Object.defineProperty(exports, 'Placeholder', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_placeholder).default;
  }
});

var _table = require('./components/table');

Object.defineProperty(exports, 'Table', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_table).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/index.js
// module id = 91
// module chunks = 1